import {Component, inject, ViewChild} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {Header} from './features/shared/header/header';
import {Navbar} from './features/shared/navbar/navbar';
import {MatDrawer, MatDrawerContainer} from '@angular/material/sidenav';
import {DrawerService} from './services/drawer-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Navbar, MatDrawer, MatDrawerContainer],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  @ViewChild('drawer') drawer!: MatDrawer;

  public readonly drawerService = inject(DrawerService);

  resetDrawerState() {
    if (this.drawerService.state()) {
      this.drawerService.state.set(false);
    }
  }
}
